'use strict';

module.exports = {};
module.exports.filler = require('./plugin.filler');
module.exports.legend = require('./plugin.legend');
module.exports.title = require('./plugin.title');



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src946329470/src/frontend/~/chart.js/src/plugins/index.js
// module id = ../../../../chart.js/src/plugins/index.js
// module chunks = 4